import { isPositiveNumber } from "et3-type-guards";

import getCoreUIStore from "../../stores/core/core-ui-store";
import {
  LOGIN_BRAND_SHARE_NARROW,
  LOGIN_BRAND_SHARE_WIDE,
  LOGIN_BREAKPOINT_NARROW,
  LOGIN_BREAKPOINT_WIDE,
  LOGIN_SCREEN_WIDTH
} from "./login-constants";

const PERCENT = 100;

export const getLoginBrandShare = (windowWidth: number): number => {
  const screenWidth = isPositiveNumber(windowWidth)
    ? windowWidth
    : LOGIN_SCREEN_WIDTH;
  const widenessSpan = LOGIN_BREAKPOINT_WIDE - LOGIN_BREAKPOINT_NARROW;
  const rawWideness = (screenWidth - LOGIN_BREAKPOINT_NARROW) / widenessSpan;
  const wideness = Math.min(Math.max(rawWideness, 0), 1);

  return (
    LOGIN_BRAND_SHARE_NARROW +
    wideness * (LOGIN_BRAND_SHARE_WIDE - LOGIN_BRAND_SHARE_NARROW)
  );
};

export const getLoginBrandWidthFromStore = (): string => {
  const share = getLoginBrandShare(getCoreUIStore().windowWidth.get());

  return `${share * PERCENT}%`;
};

export const getFlooredFontSize = (fontSize: string, minPx: number): string =>
  `max(${minPx}px, ${fontSize})`;
